import { getProductInventoryDelivery } from "./get-product-inventory-delivery.js";
const defaultDeliveryResolver = (config, availability = []) => availability.map((availability2) => getProductInventoryDelivery(config, availability2));
export {
  defaultDeliveryResolver
};
//# sourceMappingURL=default-delivery-resolver.js.map
